import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';


// Staging
if (process.env.NODE_ENV !== 'development') { // When we release the tool, we should switch the database (for better name understanding)
  firebase.initializeApp({
    apiKey: "AIzaSyCuOIkhIY9upO_lGfWdt6M8UOK-JlosKpE",
    authDomain: "sodexo-quiz-nurturing-rh.firebaseapp.com",
    databaseURL: "https://sodexo-quiz-nurturing-rh.firebaseio.com",
    projectId: "sodexo-quiz-nurturing-rh",
    storageBucket: "sodexo-quiz-nurturing-rh.appspot.com",
    messagingSenderId: "968590110395",
    appId: "1:968590110395:web:6432a733b5f3654f00439e"
  });
}

// Production
if (process.env.NODE_ENV === 'development') {
  firebase.initializeApp({
    apiKey: "AIzaSyCuOIkhIY9upO_lGfWdt6M8UOK-JlosKpE",
    authDomain: "sodexo-quiz-nurturing-rh.firebaseapp.com",
    databaseURL: "https://sodexo-quiz-nurturing-rh.firebaseio.com",
    projectId: "sodexo-quiz-nurturing-rh",
    storageBucket: "sodexo-quiz-nurturing-rh.appspot.com",
    messagingSenderId: "968590110395",
    appId: "1:968590110395:web:6432a733b5f3654f00439e"
  });
}

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js